export default {
	outline: '#ccc',
	seafoam: '#c8e4e2',
	darkGray: '#666',
	highlight: '#f1f1f1'
}